/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class DropdownUtilsService {

  constructor(private translateService: TranslateService) {
  }

  public getDropdownTranslations(values: string[], path: string): any[] {
    const translations: any[] = [];
    if (values) {
      values.forEach(val => {
        this.translateService
          .get(path + '.' + val)
          .subscribe(res => {
            translations.push({value: val, label: res});
          });
      });
    }
    return translations;
  }

  public getDropdownTranslationsForBooleanValues(values: { value: boolean, translationKey: string }[], path: string): any[] {
    const translations: any[] = [];
    if (values) {
      values.forEach(val => {
        this.translateService
          .get(path + '.' + val.translationKey)
          .subscribe(res => {
            translations.push({value: val.value, label: res});
          });
      });
    }
    return translations;
  }

}
